import { Component, Input, OnInit } from "@angular/core";

const IconSizes = {
  _16x16: {
    height: 16,
    width: 16,
  },
  _24x24: {
    height: 24,
    width: 24,
  },
};

@Component({
  selector: "sprite-icon",
  template: `
    <svg
      [attr.xmlns:xlink]="'http://www.w3.org/1999/xlink'"
      [attr.xmlns]="'http://www.w3.org/2000/svg'"
      [attr.height]="size.height"
      [attr.width]="size.width"
      [attr.class]="classes">
      <use [attr.xlink:href]="iconID" />
    </svg>
`,
})
class SpriteIconComponent implements OnInit {
  @Input() public icon: string;
  @Input() private size = IconSizes._24x24;
  @Input() private className = "";
  private classes: string;
  private iconID: string;

  public ngOnInit() {
    this.classes = `sprite-icon ${this.className}`;
    this.iconID = `#ic-${this.icon}`;
  }
}

export { SpriteIconComponent, IconSizes };



// WEBPACK FOOTER //
// ./src/app/ui-library/sprite-icon/sprite-icon.component.ts